import { AccordionProps, Box } from '@mui/material';
import { ForwardedRef, forwardRef, ReactNode } from 'react';

import { HBIcon } from '../HBIcon/HBIcon';
import { HBAccordionDetails, HBAccordionRootStyle, HBAccordionSummary } from './HBAccordion.styles';

export interface HBAccordionProps extends Omit<AccordionProps, 'ref' | 'children'> {
  summary?: ReactNode;
  detail?: ReactNode;
  customSummary?: ReactNode;
}

export const HBAccordion = forwardRef(
  <T extends HTMLDivElement>(props: HBAccordionProps, ref: ForwardedRef<T>) => {
    const { summary, customSummary, detail, ...rest } = props;
    return (
      <HBAccordionRootStyle ref={ref} {...rest}>
        <HBAccordionSummary
          expandIcon={customSummary ? null : <HBIcon size="medium" type="angleDown" />}
        >
          {summary && <Box sx={{ width: '100%' }}>{summary}</Box>}
          {customSummary ? customSummary : null}
        </HBAccordionSummary>

        <HBAccordionDetails>{detail}</HBAccordionDetails>
      </HBAccordionRootStyle>
    );
  },
);

HBAccordion.displayName = 'HBAccordion';
